<template>
    <div v-if="maquina" class="z-70 fixed fixed top-0 left-0 w-full h-full flex items-center justify-center">
        <div @click="maquina = null" class="absolute top-0 left-0 w-full h-full bg-blue-400 z-70 opacity-50"></div>
        <div class="bg-white relative z-70 shadow-lg rounded-lg w-full max-w-6xl">
            <div class="p-8">
                <div>
                    <div class="mb-3">
                        <label>
                            <span>Nombre de la máquina</span>
                            <input v-model="maquina.nombre_de_la_maquina" type="text" class="input w-full border mt-2" placeholder="Nombre de la máquina" />
                        </label>
                    </div>
                </div>
                <div class="flex justify-end">
                    <button v-bind:class="{'opacity-50 cursor-not-allowed': !maquina.num, 'cursor-pointer': maquina.num}" @click="remove()" class="mt-4 mr-4 dropdown-toggle button text-white bg-theme-11 shadow-md flex items-center"> 
                        <XIcon class="mr-2"/>
                        Eliminar
                    </button>
                    <button v-bind:class="{'opacity-50 cursor-not-allowed': !canSave(), 'cursor-pointer': canSave()}" @click="canSave() && save()" class="mt-4 dropdown-toggle button text-white bg-theme-1 shadow-md flex items-center"> 
                        <SaveIcon class="mr-2"/>
                        Guardar
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    components: {
    },
    data() {
        return {
            maquina: null
        };
    },
    mounted() {
        window.bus.$on("modalCrearMaquinaria", (maquina) => {
            console.log('entraa aqui también');
            this.maquina = {
                num: maquina.num ? maquina.num : null,
                nombre_de_la_maquina: maquina.nombre_de_la_maquina ? maquina.nombre_de_la_maquina : ''
            }
        });
    },
    methods: {
        canSave() {
            let errors = [];
            Object.keys(this.maquina).forEach((key) => {
                let error = 0;
                error = (this.maquina[key]=='')?1:0;
                errors.push(error);
            });
            errors = errors.reduce((a,b) => a+b);
            if(errors) return false;
            return true;
        },
        remove() {
            if(confirm('¿Seguro? La maquina quedará eliminada.')) {
                this.maquina.desactivado = 1;
                this.save();
            }
        },
        async save() {
            let response = await CmsApi.hook('/hooks/save/', {
                'action': 'maquinaria',
                'data': JSON.stringify(this.maquina),
                'token': this.$cookie.get("token")
            });
            if(response.success) {
                window.bus.$emit("reloadDataFromServer", {});
                this.maquina = null;
            } else {
                console.log(response)
            }
        }
    }
};
</script>